import { v4 as uuidv4 } from 'uuid';

import { Z_SESSION_COOKIE_KEY } from '../constants/session';
import { getCookie, setCookie } from '../utils/cookie';

export const refreshSession = () => {
  const cookie = getCookie(Z_SESSION_COOKIE_KEY);
  if (!cookie) {
    setCookie(Z_SESSION_COOKIE_KEY, uuidv4(), 60 * 30);
  }
};
